import { render } from "./userManageCrud.vue?vue&type=template&id=6f37390e"
import script from "./userManageCrud.vue?vue&type=script&lang=jsx"
export * from "./userManageCrud.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__